<div
  stchPopover
  [stchPopoverArrow]="true"
  [stchPopoverContent]="popoverTemplate"
  [stchPopoverInnerShadow]="true"
  stchPopoverPlacement="right"
  [stchPopoverDisabled]="!minimized"
  stchPopoverTrigger="click"
  >
  <app-sidebar-item
    title="Folders"
    icon="sapphire-folders"
    class="rounded hover:bg-hover"
    [depth]="team ? 2 : 0"
    [expandable]="true"
    [expanded]="expanded | lsValue : application : team?.id"
    [minimized]="minimized"
    [active]="currentTeamId === team?.id && sidebarFilter === 'all_sheetFolders'"
    [actions]="[{
      icon: 'sapphire-plus',
      template: sheetFolderQuickFormTemplate,
      until: quickFormPopoverClose,
      appearance: 'dialog'
    }]"
    (onExpand)="expanded.set($event, application, team?.id)"
    (appClick)="selectFilter.emit('all_sheetFolders')"
    appSidebarContextMenu="all_sheetFolders"
    >
    <app-context-menu-state-indicator
      appearance="sapphire"
      svgIcon="sapphire-filters"
      appSheetFoldersListContextMenu
      />
    </app-sidebar-item>
  </div>

  @if (!minimized) {
    <div
      class="collapseable-body"
      [@heightAnimation]="(expanded | lsValue : application : team?.id) ? 'show' : 'hide'"
      >
      <ng-container *ngTemplateOutlet="contentTemplate" />
    </div>
  }

  <ng-template #popoverTemplate>
    @if (minimized) {
      <div
        class="popover-body"
        >
        <ng-container *ngTemplateOutlet="contentTemplate" />
      </div>
    }
  </ng-template>

  <ng-template #contentTemplate>
    <app-side-bar-sheet-folders-tree [filters]="filters" [team]="team" [itemCreateFormTemplate]="sheetFolderQuickFormTemplate" />
  </ng-template>

  <ng-template #sheetFolderQuickFormTemplate let-parentId="parentId">
    <div class="quick-form-container">
      <app-sheet-folder-quick-form
        [autofocus]="true"
        [parentId]="parentId"
        [inline]="true"
        [showMore]="true"
        [showCancel]="true"
        (close)="quickFormPopoverClose.next()"
        (more)="handleMore($event)"
        />
      </div>
    </ng-template>
